import type { Voice } from '../api/types';
import { safeMediaUrl } from '../features/studio/studio-content';

/** Вертикальный сдвиг портрета в шаре. Аватарки каталога — готовые фото лица (квадрат, 2:3, 16:9): лицо в верхней трети кадра */
const PORTRAIT_Y = 25;

/** Портрет фоном шара: вписан по меньшей стороне (cover), по вертикали — y %. У шаблона было 165% auto под арты персонажей в полный рост;
    фото лица каталога так увеличивались в 1,6–2,5 раза, и в шар попадал один лоб. Адрес — только безопасный https */
export function portraitOrb(url: string | null, y = PORTRAIT_Y): string | null {
  const safe = safeMediaUrl(url);
  /* без кавычек, как у шаблона: строка встаёт в атрибут style="…"; скобки, кавычки и пробелы адреса кодируются */
  return safe ? `url(${safe.replace(/[()'"\\\s]/g, c => encodeURIComponent(c))}) 50% ${y}%/cover no-repeat` : null;
}

/** Аватарка голоса для кружков списков (20–44 px): превью 128 px, если сервер его дал, иначе полный размер */
export function avatarThumb(voice: { avatar_url?: string | null; avatar_thumb_url?: string | null }): string | null {
  return voice.avatar_thumb_url || voice.avatar_url || null;
}

/** Шар голоса как у шаблона и виджета (assets/bot-demo.js O(a,b)), не линейный градиент; у голоса персонажа — его портрет фоном шара,
    как CHARS.orb шаблона (сдвиг портрета по вертикали сервер не передаёт — берётся общий для портретов шаблона).
    Шар списков — с превью аватарки; full — полный размер для героя карточки голоса */
export function voiceOrb(voice: Pick<Voice, 'orb' | 'avatar_url' | 'avatar_thumb_url'>, full = false): string | null {
  const orb = voice.orb as Voice['orb'] | undefined;
  return portraitOrb(full ? voice.avatar_url : avatarThumb(voice)) ?? (orb ? `conic-gradient(from 210deg at 50% 50%,${orb.from},${orb.to},${orb.from})` : null);
}
